import { DateWrapper } from 'kuaidong-lib'
import DrillReport from '../views/drill-report/DrillReport.vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const RecordLayout = () => import('../views/broadcast-gymnastics/RecordLayout.vue')
const RecordPage = () => import('../views/broadcast-gymnastics/Record.vue')
const Check = () => import('../views/broadcast-gymnastics/Check.vue')
const Detail = () => import('../views/broadcast-gymnastics/Detail.vue')
const TopStudents = () => import('../views/broadcast-gymnastics/TopStudents.vue')
const DrillReportLayout = () => import('../views/broadcast-gymnastics/DrillReportLayout.vue')
const ReminderPoster = () => import('../views/homework/HomeworkReminderPoster.vue')
const StudentSelect = () => import('../views/homework/HomeworkStudentSelect.vue')
const ListExport = () => import('../views/broadcast-gymnastics/ListExport.vue')

const prefix = 'gymnastics-check'
const routes: RouteConfig[] = [
  {
    path: `/${prefix}-list-export`,
    name: `${prefix}_list_export`,
    component: ListExport,
    meta: {
      title: '导出数据',
    },
  },
  {
    path: `/${prefix}-student-select`,
    name: `${prefix}_student_select`,
    component: StudentSelect,
    meta: {
      title: '选择学生',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: `/${prefix}-detail`,
    name: `${prefix}_detail`,
    component: Detail,
    meta: {
      title: '广播体操练习-班级详情',
      [GlobalConfigRouteMetaEnum.All]: true,
    },
    props: (route) => {
      const result = {
        query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
        clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
        completeCount: route.query.completeCount ? Number(route.query.completeCount) : 0,
        studentsCount: route.query.studentsCount ? Number(route.query.studentsCount) : 0,
      }

      if (result.query && result.query.date) {
        result.query.date = new DateWrapper(result.query.date).date
      }

      return result
    },
  },
  {
    path: `/${prefix}-reminder`,
    name: `${prefix}_reminder`,
    component: ReminderPoster,
    meta: {
      title: '作业提醒',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: `/${prefix}-record-layout`,
    name: `${prefix}_record_layout`,
    component: RecordLayout,
    props: (route) => {
      const result = {
        query: JSON.parse(`${route.query.query}`),
        clazz: JSON.parse(`${route.query.clazz}`),
        defaultStudent: JSON.parse(`${route.query.student}`),
        everydayReleaseId: Number(route.query.everydayReleaseId),
      }

      if (result.query && result.query.date) {
        result.query.date = new DateWrapper(result.query.date).date
      }

      return result
    },
    children: [
      {
        path: `/navigable-${prefix}-record`,
        name: `navigable_${prefix}_record`,
        component: RecordPage,
        meta: {
          title: '个人训练记录',
        },
        props: (route) => {
          const result = {
            query: JSON.parse(`${route.query.query}`),
            clazz: JSON.parse(`${route.query.clazz}`),
            everydayReleaseId: Number(route.query.everydayReleaseId),
          }

          if (result.query && result.query.date) {
            result.query.date = new DateWrapper(result.query.date).date
          }

          return result
        },
      },
    ],
  },
  {
    path: `/${prefix}`,
    name: `${prefix}`,
    component: Check,
    meta: {
      title: '检查广播体操练习',
    },
  },
  {
    path: `/${prefix}-top-students`,
    name: `${prefix}_top_students`,
    component: TopStudents,
    meta: {
      title: '优秀名单',
    },
    props: (route) => ({
      ...route.query,
      ...route.params,
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
      clazz: route.query.clazz ? JSON.parse(`${route.query.clazz}`) : null,
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
  },
  {
    path: '',
    name: `${prefix}_drill_report_layout`,
    component: DrillReportLayout,
    props: (route) => ({
      id: route.query.id,
      ids: route.query.ids ? JSON.parse(`${route.query.ids}`) : [],
      everydayReleaseId: Number(route.query.everydayReleaseId),
    }),
    children: [
      {
        path: `${prefix}-drill-report`,
        name: `${prefix}_drill_report`,
        component: DrillReport,
        props: (route) => ({ ...route.query, ...route.params }),
      },
    ],
  },
]

export function navigateToGymnasticsCheckList(router: VueRouter) {
  router.push({ name: `${prefix}` })
}
export function navigateToGymnasticsCheckRecord(router: VueRouter, query: any) {
  router.push({ query, name: `navigable_${prefix}_record` })
}
export function replaceToGymnasticsCheckRecord(router: VueRouter, query: any) {
  router.replace({ query, name: `navigable_${prefix}_record` })
}
export function navigateToGymnasticsCheckStudentList(router: VueRouter, query: any) {
  router.push({ query, name: `${prefix}_student_select` })
}
export function navigateToGymnasticsCheckReminder(router: VueRouter, query: any) {
  router.push({ query, name: `${prefix}_reminder` })
}
export function navigateToGymnasticsCheckDrillReport(router: VueRouter, query: any) {
  router.push({ query, name: `${prefix}_drill_report` })
}
export function replaceToGymnasticsCheckDrillReport(router: VueRouter, query: any) {
  router.replace({ query, name: `${prefix}_drill_report` })
}
export function navigateToGymnasticsCheckDetail(router: VueRouter, query: any) {
  router.push({ query, name: `${prefix}_detail` })
}
export function navigateToGymnasticsCheckTopStudents(router: VueRouter, query: any) {
  router.push({ query, name: `${prefix}_top_students` })
}
export function navigateToGymnasticsCheckListExport(router: VueRouter) {
  router.push({ name: `${prefix}_list_export` })
}

export function navigateToGymnasticsCheckComment(router: VueRouter, query: any) {
  router.push({ query, name: `homework_comment` })
}

export default [...routes]
